import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { passesDemoGate } from './app/core/demo/demo-gate';
import { environment } from './environments/environment';

console.log('[startup] mapsKey:', environment.mapsKey);

passesDemoGate()
  .then((allowed) => {
    if (!allowed) {
      return;
    }
    return bootstrapApplication(App, appConfig).then(() => undefined);
  })
  .catch((err) => console.error(err));
